import { styled } from "styled-components";

export const ListItemBox = styled.div<{ $isExpandable?: boolean }>`
  color: ${({ theme }) => theme.colors.textBright};
  cursor: ${({ $isExpandable = true }) => ($isExpandable ? "pointer" : "default")};
  border-radius: 4px;
  margin-bottom: 8px;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};

  &:last-child {
    margin-bottom: 0;
  }
`;
